export default "__VITE_ASSET__Berhf6eX__"